﻿/* MasterGPacks Theme v3 — theme.js */
(function(){
  'use strict';

  /* ── WAVEFORM CANVAS ── */
  function initWaveform(){
    var c=document.getElementById('wv-canvas');
    if(!c) return;
    var cx=c.getContext('2d');
    c.width=window.innerWidth; c.height=80;
    var t=0;
    var W=[
      {a:18,f:.009,s:.016,c:'rgba(0,229,255,.7)', y:52},
      {a:9, f:.016,s:.028,c:'rgba(255,45,59,.45)',y:46},
      {a:6, f:.024,s:.044,c:'rgba(0,255,157,.35)',y:58}
    ];
    (function loop(){
      cx.clearRect(0,0,c.width,c.height);
      W.forEach(function(w){
        cx.beginPath(); cx.moveTo(0,w.y);
        for(var x=0;x<=c.width;x+=2) cx.lineTo(x,w.y+Math.sin(x*w.f+t*w.s*60)*w.a);
        cx.strokeStyle=w.c; cx.lineWidth=1.5; cx.stroke();
      });
      t+=.012; requestAnimationFrame(loop);
    })();
    window.addEventListener('resize',function(){ c.width=window.innerWidth; });
  }

  /* ── EQ BARS ── */
  function initEQ(){
    var el=document.getElementById('mgp-eq-bars');
    if(!el) return;
    [.12,.28,.55,.72,.9,.78,.62,.88,.95,.7,.48,.38,.6,.82,.44,.3,.58,.74,.91].forEach(function(h,i){
      var b=document.createElement('div');
      b.style.cssText='width:3px;border-radius:2px 2px 0 0;height:'+Math.round(h*100)+'%;background:linear-gradient(to top,#00e5ff,rgba(0,229,255,.1));animation:mgpEqAnim '+(.55+Math.random()*.65).toFixed(2)+'s ease-in-out infinite alternate;animation-delay:'+(i*.05).toFixed(2)+'s;--lo:'+(h*.2).toFixed(2)+';--hi:'+h.toFixed(2);
      el.appendChild(b);
    });
  }

  /* ── NAVBAR SCROLL ── */
  function initNav(){
    var nav=document.getElementById('mgp-nav');
    if(!nav) return;
    window.addEventListener('scroll',function(){
      nav.style.background=window.scrollY>50?'rgba(6,6,10,.99)':'rgba(6,6,10,.92)';
    });
  }

  /* ── CAROUSELS ── */
  function initCarousels(){
    document.querySelectorAll('.mgp-arr').forEach(function(btn){
      btn.addEventListener('click',function(){
        var dir=btn.classList.contains('mgp-arr-r')?1:-1;
        var car=btn.closest('.mgp-car-wrap').querySelector('.mgp-car');
        if(car) car.scrollBy({left:dir*580,behavior:'smooth'});
      });
    });
  }

  /* ── PILLS ── */
  function initPills(){
    document.querySelectorAll('.mgp-pill').forEach(function(p){
      p.addEventListener('click',function(){
        var row=p.closest('.mgp-pills');
        if(row) row.querySelectorAll('.mgp-pill').forEach(function(x){ x.classList.remove('active'); });
        p.classList.add('active');
      });
    });
  }

  

  /* ── CART COUNT ── */
  window.mgpAddCart=function(){
    var c=document.getElementById('mgp-cart-count');
    if(!c) return;
    var n=parseInt(c.dataset.count||'0')+1;
    c.dataset.count=n;
    c.textContent='('+n+')';
  };

  /* ── QTY BUTTONS ── */
  function initQty(){
    document.querySelectorAll('.mgp-qty-btn').forEach(function(btn){
      btn.addEventListener('click',function(){
        var inp=btn.closest('.mgp-qty-wrap,form').querySelector('input[name="quantity"],input[name^="updates"]');
        if(!inp) return;
        var v=parseInt(inp.value)||1;
        inp.value=btn.dataset.action==='plus'?v+1:Math.max(1,v-1);
      });
    });
  }

  /* ── THUMBNAILS ── */
  function initThumbs(){
    document.querySelectorAll('.mgp-thumb').forEach(function(t){
      t.addEventListener('click',function(){
        var main=document.getElementById('mgp-main-img');
        if(main&&t.dataset.full) main.src=t.dataset.full;
        document.querySelectorAll('.mgp-thumb').forEach(function(x){ x.classList.remove('active'); });
        t.classList.add('active');
      });
    });
  }

  /* ── CART REMOVE ── */
  window.mgpRemoveItem=function(key){
    fetch('/cart/change.js',{
      method:'POST',
      headers:{'Content-Type':'application/json'},
      body:JSON.stringify({id:key,quantity:0})
    }).then(function(){ location.reload(); });
  };

  /* ── VARIANT SELECT ── */
  window.mgpSelectVariant=function(btn){
    document.querySelectorAll('.mgp-variant-btn').forEach(function(b){ b.classList.remove('active'); });
    btn.classList.add('active');
    var inp=document.getElementById('mgp-variant-id');
    if(inp) inp.value=btn.dataset.vid;
    var priceEl=document.getElementById('mgp-product-price');
    if(priceEl&&btn.dataset.price) priceEl.textContent=btn.dataset.price;
  };

  /* ── HERO MACHINES BAND ── */
  function initHeroBand(){
    var band=document.getElementById('mgp-hero-band');
    if(!band) return;
    var machines=[
      {icon:'🎛️',name:'TR-808',   h:170},
      {icon:'🎹',name:'MPC 2000', h:195},
      {icon:'🎚️',name:'SP-404',  h:155},
      {icon:'🥁',name:'Percussão',h:182},
      {icon:'🎉',name:'Carnaval', h:160},
      {icon:'🕹️',name:'Games',   h:188},
      {icon:'🌿',name:'Orgânicos',h:172},
      {icon:'🤖',name:'VS · IA',  h:178},
    ];
    machines.forEach(function(m){
      var d=document.createElement('div');
      d.className='mgp-mband-col';
      d.innerHTML='<div class="mgp-mband-block" style="height:'+m.h+'px"><div class="mgp-mband-icon">'+m.icon+'</div><div class="mgp-mband-nm">'+m.name+'</div></div>';
      band.appendChild(d);
    });
  }

  /* ── YOUTUBE MODAL ── */
  window.mgpOpenYT = function(title, ytId) {
    try {
      var modal = document.getElementById('mgp-yt-modal');
      var frame = document.getElementById('mgp-yt-frame');
      var titleEl = document.getElementById('mgp-yt-title');
      var fallback = document.getElementById('mgp-yt-fallback');
      if (!modal) return;
      if (titleEl) titleEl.textContent = title;
      if (frame) frame.src = 'https://www.youtube-nocookie.com/embed/' + ytId + '?autoplay=1&rel=0&modestbranding=1';
      if (fallback) fallback.href = 'https://www.youtube.com/watch?v=' + ytId;
      modal.classList.add('open');
    } catch(e) {}
  };

  window.mgpCloseYT = function() {
    try {
      var modal = document.getElementById('mgp-yt-modal');
      var frame = document.getElementById('mgp-yt-frame');
      if (modal) modal.classList.remove('open');
      if (frame) frame.src = '';
    } catch(e) {}
  };

  /* ── MODAL DE COMPRA (nome/botão comprar → modal → checkout) ── */
  window.mgpOpenBuyModal = function(handle, title, price, imgUrl, variantId) {
    try {
      var modal   = document.getElementById('mgp-buy-modal');
      var imgEl   = document.getElementById('mgp-bm-img');
      var titleEl = document.getElementById('mgp-bm-title');
      var priceEl = document.getElementById('mgp-bm-price');
      var descEl  = document.getElementById('mgp-bm-desc');
      var btnBuy  = document.getElementById('mgp-bm-buy');
      var btnCart = document.getElementById('mgp-bm-cart');
      if (!modal) return;

      if (imgEl)   imgEl.src = imgUrl || '';
      if (titleEl) titleEl.textContent = title || '';
      if (priceEl) priceEl.textContent = price || '';
      if (descEl)  descEl.innerHTML = '<span style="color:#4a4a60;font-size:.72rem;">Carregando...</span>';

      /* Buscar descrição */
      if (handle) {
        fetch('/products/' + handle + '.js')
          .then(function(r) { return r.json(); })
          .then(function(p) {
            if (descEl) {
              var raw = p.description || '';
              var clean = raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
              descEl.textContent = clean.length > 300 ? clean.substring(0, 300) + '…' : clean;
            }
          })
          .catch(function() { if (descEl) descEl.textContent = ''; });
      }

      /* Botão Comprar → MP Checkout direto via MgpMpLinks */
      if (btnBuy) {
        btnBuy.textContent = 'Comprar agora ⚡';
        btnBuy.disabled = false;
        btnBuy.onclick = function(e) {
          e.preventDefault();
          /* sempre usa Shopify checkout — MP Pix webhook garante entrega automática */
          btnBuy.textContent = 'Aguarde...';
          btnBuy.disabled = true;
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
          })
          .then(function() {
            window.location.href = '/checkout';
          })
          .catch(function() {
            btnBuy.textContent = 'Comprar agora ⚡';
            btnBuy.disabled = false;
            mgpShowToast('Erro ao processar. Tente novamente.');
          });
        };
      }

      /* Botão +Carrinho no modal → adiciona + fecha modal */
      if (btnCart) {
        btnCart.onclick = function() {
          mgpAjaxCart(parseInt(variantId));
          mgpCloseBuyModal();
        };
      }

      modal.classList.add('open');
    } catch(err) { console.error('mgpOpenBuyModal:', err); }
  };

  window.mgpCloseBuyModal = function() {
    try {
      var modal = document.getElementById('mgp-buy-modal');
      if (modal) modal.classList.remove('open');
    } catch(e) {}
  };

  /* ── AJAX ADD TO CART ── */
  window.mgpAjaxCart = function(variantId) {
    try {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
      })
      .then(function() {
        mgpShowToast('Adicionado ao carrinho!');
        mgpOpenDrawer();
      })
      .catch(function() { mgpShowToast('Erro ao adicionar.'); });
    } catch(e) {}
  };

  /* ── TOAST ── */
  window.mgpShowToast = function(msg) {
    try {
      var t = document.getElementById('mgp-toast');
      if (!t) return;
      t.textContent = msg;
      t.classList.add('show');
      setTimeout(function() { t.classList.remove('show'); }, 2800);
    } catch(e) {}
  };

  /* ── FECHAR MODAIS AO CLICAR NO FUNDO ── */
  document.addEventListener('click', function(e) {
    try {
      var ytModal  = document.getElementById('mgp-yt-modal');
      var buyModal = document.getElementById('mgp-buy-modal');
      if (ytModal  && e.target === ytModal)  mgpCloseYT();
      if (buyModal && e.target === buyModal) mgpCloseBuyModal();
    } catch(e) {}
  });

  /* ── EVENTOS DOS CARDS ── */
  function initCards() {
    document.addEventListener('click', function(e) {
      try {
        var card = e.target.closest('.mgp-pcard');
        if (!card) return;

        var handle = card.dataset.handle || '';
        var title  = card.dataset.title  || '';
        var price  = card.dataset.price  || '';
        var img    = card.dataset.img    || '';
        var vid    = card.dataset.vid    || '';
        var url    = card.dataset.url    || '';
        var yt     = card.dataset.yt     || '';

        /* +🛒 → adiciona ao carrinho + abre drawer */
        if (e.target.closest('.mgp-ajax-cart')) {
          e.preventDefault();
          e.stopPropagation();
          mgpAjaxCart(parseInt(vid));
          return;
        }

        /* Botão COMPRAR → add ao carrinho + vai direto para checkout */
        if (e.target.closest('.mgp-btn-buy')) {
          e.preventDefault();
          e.stopPropagation();
          var buyBtn = e.target.closest('.mgp-btn-buy');
          buyBtn.textContent = 'Aguarde...';
          buyBtn.style.opacity = '0.7';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: parseInt(vid), quantity: 1 })
          })
          .then(function() { window.location.href = '/checkout'; })
          .catch(function() {
            buyBtn.textContent = 'Comprar';
            buyBtn.style.opacity = '1';
            mgpShowToast('Erro ao processar. Tente novamente.');
          });
          return;
        }

        /* Nome do produto → abre modal com descrição */
        if (e.target.closest('.mgp-open-buy')) {
          e.preventDefault();
          e.stopPropagation();
          mgpOpenBuyModal(handle, title, price, img, vid, url);
          return;
        }

        /* Capa → YouTube se tiver, senão modal */
        if (e.target.closest('.mgp-cover-click')) {
          e.preventDefault();
          e.stopPropagation();
          if (yt) {
            mgpOpenYT(title, yt);
          } else {
            mgpOpenBuyModal(handle, title, price, img, vid, url);
          }
          return;
        }
      } catch(err) { console.error('initCards click:', err); }
    });
  }

  /* ── CART DRAWER ── */
  function mgpMoneyFmt(cents) {
    return 'R$\u00a0' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function mgpRenderDrawer(cart) {
    try {
      var itemsEl = document.getElementById('mgp-drawer-items');
      var emptyEl = document.getElementById('mgp-drawer-empty');
      var totalEl = document.getElementById('mgp-drawer-total-price');
      var countEl = document.getElementById('mgp-cart-count');
      if (!itemsEl) return;

      if (countEl) countEl.textContent = '(' + cart.item_count + ')';
      if (totalEl) totalEl.textContent = mgpMoneyFmt(cart.total_price);

      /* Limpar itens anteriores mantendo o empty */
      Array.from(itemsEl.children).forEach(function(k) {
        if (!k.id || k.id !== 'mgp-drawer-empty') k.remove();
      });

      if (cart.item_count === 0) {
        if (emptyEl) emptyEl.style.display = 'block';
        return;
      }
      if (emptyEl) emptyEl.style.display = 'none';

      cart.items.forEach(function(item, idx) {
        var div = document.createElement('div');
        div.className = 'mgp-di';
        var img = item.featured_image && item.featured_image.url
          ? item.featured_image.url.replace('http:', 'https:') : '';
        var lineNum = idx + 1;
        div.innerHTML =
          (img
            ? '<img class="mgp-di-img" src="' + img + '" alt="">'
            : '<div class="mgp-di-img" style="background:#10102e;border-radius:6px;display:flex;align-items:center;justify-content:center;font-size:1.4rem;">🎛️</div>') +
          '<div class="mgp-di-info">' +
            '<div class="mgp-di-title">' + item.product_title + '</div>' +
            '<div class="mgp-di-meta">WAV · 16bit &nbsp;·&nbsp; Qtd: ' + item.quantity + '</div>' +
            '<div class="mgp-di-bottom">' +
              '<div class="mgp-di-price">' + mgpMoneyFmt(item.line_price) + '</div>' +
              '<button class="mgp-di-remove" data-line="' + lineNum + '">✕ remover</button>' +
            '</div>' +
          '</div>';
        itemsEl.appendChild(div);
      });

      /* Event delegation no container — funciona sempre, mesmo após re-render */
      itemsEl.onclick = function(ev) {
        var btn = ev.target.closest('.mgp-di-remove');
        if (btn) {
          ev.preventDefault();
          mgpRemoveDrawerItem(parseInt(btn.dataset.line, 10));
        }
      };
    } catch(err) { console.error('mgpRenderDrawer:', err); }
  }

  window.mgpOpenDrawer = function() {
    try {
      fetch('/cart.js')
        .then(function(r) { return r.json(); })
        .then(function(cart) {
          mgpRenderDrawer(cart);
          var d = document.getElementById('mgp-drawer');
          var o = document.getElementById('mgp-drawer-overlay');
          if (d) d.classList.add('open');
          if (o) o.classList.add('open');
        });
    } catch(e) {}
  };

  window.mgpCloseDrawer = function() {
    try {
      var d = document.getElementById('mgp-drawer');
      var o = document.getElementById('mgp-drawer-overlay');
      if (d) d.classList.remove('open');
      if (o) o.classList.remove('open');
    } catch(e) {}
  };

  window.mgpRemoveDrawerItem = function(line) {
    try {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: 0 })
      })
      .then(function(r) { return r.json(); })
      .then(function(cart) { mgpRenderDrawer(cart); });
    } catch(e) {}
  };

  window.mgpApplyCoupon = function() {
    try {
      var code = (document.getElementById('mgp-coupon-input') || {}).value || '';
      if (!code.trim()) return;
      window.location.href = '/checkout?discount=' + encodeURIComponent(code.trim());
    } catch(e) {}
  };

  /* ── CART BUTTON: abre drawer ── */
  function initCartBtn() {
    try {
      var btn = document.querySelector('.mgp-nav-cart-btn');
      if (!btn) return;
      btn.addEventListener('click', function(e) {
        e.preventDefault();
        mgpOpenDrawer();
      });
    } catch(e) {}
  }

  /* ── EMAIL SIGNUP BAR ── */
  (function() {
    try {
      var bar = document.getElementById('mgp-emailbar');
      if (!bar) return;
      if (window.location.pathname.indexOf('/checkout') === 0) {
        bar.classList.add('hidden');
        return;
      }
      if (localStorage.getItem('mgp_emailbar_closed') === '1') {
        bar.classList.add('hidden');
      }
    } catch(e) {}
  })();

  window.mgpEmailBarClose = function() {
    try {
      var bar = document.getElementById('mgp-emailbar');
      if (bar) bar.classList.add('hidden');
      document.documentElement.style.setProperty('--mgp-bar-h', '0px');
      localStorage.setItem('mgp_emailbar_closed', '1');
    } catch(e) {}
  };

  window.mgpEmailBarSubmit = function(e) {
    e.preventDefault();
    try {
      var email = (document.getElementById('mgp-emailbar-input') || {}).value || '';
      if (!email.trim()) return;
      var btn  = document.querySelector('.mgp-emailbar-btn');
      var form = document.getElementById('mgp-emailbar-form');
      var succ = document.getElementById('mgp-emailbar-success');
      if (btn) { btn.textContent = 'Enviando...'; btn.disabled = true; }
      var BKEY = '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';
      Promise.all([
        fetch('https://api.brevo.com/v3/contacts', {
          method: 'POST',
          headers: {'api-key': BKEY, 'Content-Type': 'application/json'},
          body: JSON.stringify({email: email.trim(), listIds: [2], updateEnabled: true, attributes: {ORIGEM: 'emailbar'}})
        }),
        fetch('https://api.brevo.com/v3/smtp/email', {
          method: 'POST',
          headers: {'api-key': BKEY, 'Content-Type': 'application/json'},
          body: JSON.stringify({
            to: [{email: email.trim()}],
            templateId: 8,
            sender: {name: 'MasterGPacks', email: 'contato@mastergpacks.com'}
          })
        })
      ]).then(function() {
        if (form) form.style.display = 'none';
        if (succ) succ.style.display = 'inline';
        localStorage.setItem('mgp_emailbar_closed', '1');
        setTimeout(function() { window.mgpEmailBarClose(); }, 5000);
      }).catch(function() {
        if (form) form.style.display = 'none';
        if (succ) succ.style.display = 'inline';
        localStorage.setItem('mgp_emailbar_closed', '1');
        setTimeout(function() { window.mgpEmailBarClose(); }, 5000);
      });
    } catch(err) {}
  };

  /* ── INIT ── */
  document.addEventListener('DOMContentLoaded', function() {
    try { initWaveform(); }    catch(e) {}
    try { initEQ(); }          catch(e) {}
    try { initNav(); }         catch(e) {}
    try { initCarousels(); }   catch(e) {}
    try { initPills(); }       catch(e) {}
    try { initQty(); }         catch(e) {}
    try { initThumbs(); }      catch(e) {}
    try { initHeroBand(); }    catch(e) {}
    try { initCards(); }       catch(e) {}
    try { initCartBtn(); }     catch(e) {}
  });

})();


/* Checkout via Shopify — dispara download digital automaticamente */
window.mgpShopifyCheckout = function(btn) {
  var vid = btn.getAttribute('data-variant-id');
  if (!vid) return;
  var orig = btn.textContent;
  btn.textContent = 'Aguarde...';
  btn.disabled = true;
  fetch('/cart/add.js', {
    method: 'POST',
    headers: {'Content-Type': 'application/json'},
    body: JSON.stringify({id: parseInt(vid), quantity: 1})
  }).then(function() {
    window.location.href = '/checkout';
  }).catch(function() {
    btn.textContent = orig;
    btn.disabled = false;
  });
};
